import { FormControlLabel, Radio, RadioGroup, Rating, Stack, TextField } from '@mui/material';
import './styles.css'
import { sxQuestionTextField, sxRating } from '../sxProps';
import { QuestionProps } from '../../../interfaces/props/QuestionProps';
import { QuestionsEnum } from '../../../interfaces/enum/QuestionsEnum';
import { ChangeEvent, SyntheticEvent, useEffect, useState } from 'react';

function Question(props: QuestionProps) {
    const [value, setValue] = useState<string>('');
    const [rating, setRating] = useState<number | null>(0);
    const [error, setError] = useState<boolean>(false);

    useEffect(() => {
        if(props.confirm){
            if(props.question.indObrigatorio === 'S' && value === '' && rating === 0){
                props.handleConfirmation();
                setError(true);
            }
            else {
                setError(false);
            }
        }
    }, [props.confirm])

    const handleChange= (event: ChangeEvent<HTMLInputElement | HTMLInputElement>) => {
        setValue(event.target.value);
        props.handleAnswer(event.target.value, props.index);
    }

    const handleRating = (event: SyntheticEvent, newValue: number | null) => {
        setRating(newValue);
        props.handleAnswer(`${newValue}`, props.index);
    }

    return (
        <div className="question-holder">
            <h1 className="question">
                {props.question.descrQuestao}
            </h1>
            <div className="answer">
                {props.question.tipoRespConfig === QuestionsEnum.fiveStars &&
                    <Stack spacing={1}>
                        <Rating name="size-medium" defaultValue={2} sx={sxRating} value={rating} onChange={handleRating}/>
                    </Stack>
                }
                {props.question.tipoRespConfig === QuestionsEnum.dissertation &&
                    <div className="question-textfield">
                        <TextField
                            id="outlined-multiline-static"
                            onChange={handleChange}
                            value={value}
                            sx={sxQuestionTextField}
                            multiline
                            rows={4}
                            defaultValue="Default Value"
                            fullWidth
                        />
                    </div>
                }
                {props.question.tipoRespConfig === QuestionsEnum.yesOrNo &&
                    <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    value={value}
                    row
                    onChange={handleChange}
                    >
                        <FormControlLabel value={'withinArea'} control={<Radio size='small'/>}
                            label={
                                <span className='location-radio-button'>
                                    Sim
                                </span> 
                        }/>
                        <FormControlLabel value={'outsideArea'} control={<Radio size='small'/>} 
                            label={
                                <span className='location-radio-button'>
                                    Não
                                </span>
                        }/>
                    </RadioGroup>
                }
            </div>
            {error && <span className='error-message'>Campo obrigatório</span>}
        </div>
    )
}

export default Question;